import { useLocalSearchParams } from 'expo-router';
import { KpLiveLessonView } from '@/components/kursi-play-v2/KpLiveLessonView';
import type { RuntimeBase } from '@/features/unified-learning/runtime/runtimeRoutes';

export function RuntimeLessonScreen({ runtimeBase: _runtimeBase }: { runtimeBase: RuntimeBase }) {
  const { slug, lessonId, uid, token } = useLocalSearchParams<{
    slug: string;
    lessonId: string;
    uid: string;
    token: string;
  }>();

  return (
    <KpLiveLessonView
      lessonId={lessonId ?? ''}
      slug={slug ?? ''}
      userId={uid ?? ''}
      guestSessionToken={token ?? ''}
    />
  );
}
